import { handleActions } from 'redux-actions';
import { SetActiveRecommendedSeats, setActiveRecommendedSeats, toggleActiveRecommendedSeats } from './actions';

const initialState = false;

const activeRecommendedSeatsReducer = handleActions(
	{
		[setActiveRecommendedSeats.toString()]: (_, { payload }: SetActiveRecommendedSeats) => payload,
		[toggleActiveRecommendedSeats.toString()]: state => !state
	},
	initialState
);

export default activeRecommendedSeatsReducer;
